export interface IYardAddonOrderRequest {

    YardProductID: number;
    LicenseID: number;
    CCardID: number;
    Initials: string;

}

export class YardAddonOrderRequest implements IYardAddonOrderRequest {

    YardProductID: number;
    LicenseID: number;
    CCardID: number;
    Initials: string;

}